module.exports = __webpack_public_path__ + "static/kak-c696ba8b8351ad8fb7742ca505064968.png";